export default "__VITE_ASSET__DmXyn2fn__"